import { useQuery } from '@tanstack/react-query';
import { timesheetService } from '@/services/timesheets/timesheetService';
import { timesheetQueryKeys } from './queryKeys';
import type { TimeEntryComment } from '@/services/timesheets/types';

export const useTimeEntryComments = (entryId: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: timesheetQueryKeys.timeEntryComments(entryId),
    queryFn: () => timesheetService.getTimeEntryComments(entryId),
    enabled: enabled && !!entryId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
